module.exports = __webpack_public_path__ + "static/media/EurekaEmpresarial.d3bb5a72.png";